import { Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { SkeletonLabel } from "@/components/Skeleton";
import { useAnalyticsCallDisconnectedBy } from "@/hooks/useAnalyticsCallDisconnectedBy/useAnalyticsCallDisconnectedBy";
import { useCall } from "@/hooks/useCall/useCall";
import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

function SectionDisconnectedByBody() {
  const { t } = useTranslation();
  const { call } = useCall();

  const { disconnectedBy, loading, error } = useAnalyticsCallDisconnectedBy(
    call?.id ?? "",
    call?.createdAt ?? ""
  );

  if (loading) {
    return <SkeletonLabel w={80} h={18} data-test="disconnected-by-skeleton" />;
  }

  if (error || !disconnectedBy) {
    return null;
  }

  const displayValue =
    disconnectedBy === "AGENT"
      ? t("call_context.disconnected_by_agent")
      : t("call_context.disconnected_by_external");

  return <Typography variant="bodyMediumS">{displayValue}</Typography>;
}

export function SectionDisconnectedBy() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <SectionLayout data-test="disconnected-by-section">
      <SectionHeader>{t("call_context.disconnected_by")}</SectionHeader>
      <SectionDisconnectedByBody />
    </SectionLayout>
  );
}
